export default __webpack_public_path__ + "static/media/ZEE-BNB.e62acf8c.svg";